/* eslint-disable @typescript-eslint/no-explicit-any */
export function mapToString(value) {
    if (value != null) {
        if (typeof value === 'string') {
            return value;
        }
        else {
            return value.toString();
        }
    }
    else {
        return '';
    }
}
export function mapToStringOrUndefined(value) {
    if (value != null) {
        if (typeof value === 'string') {
            return value;
        }
        else {
            return value.toString();
        }
    }
    else {
        return undefined;
    }
}
export function mapToNumber(value) {
    if (value != null) {
        switch (typeof value) {
            case 'number':
                return value;
            case 'string': {
                const number = parseFloat(value);
                if (isFinite(number)) {
                    return number;
                }
                else {
                    return 0;
                }
            }
            default:
                return 0;
        }
    }
    else {
        return 0;
    }
}
export function mapToNumberOrUndefined(value) {
    if (value != null) {
        switch (typeof value) {
            case 'number':
                return value;
            case 'string': {
                const number = parseFloat(value);
                if (isFinite(number)) {
                    return number;
                }
                else {
                    return undefined;
                }
            }
            default:
                return undefined;
        }
    }
    else {
        return undefined;
    }
}
export function mapToBoolean(value) {
    if (value != null) {
        switch (typeof value) {
            case 'boolean':
                return value;
            case 'number':
                return value !== 0;
            case 'string':
                return value.toLowerCase() === 'true';
            case 'object':
                return true;
            default:
                return false;
        }
    }
    else {
        return false;
    }
}
export function mapToBooleanOrUndefined(value) {
    if (value != null) {
        switch (typeof value) {
            case 'boolean':
                return value;
            case 'number':
                return value !== 0;
            case 'string':
                return value.toLowerCase() === 'true';
            case 'object':
                return true;
            default:
                return undefined;
        }
    }
    else {
        return undefined;
    }
}
export function mapToArray(value) {
    if (value != null) {
        if (Array.isArray(value)) {
            return value;
        }
        else {
            return [];
        }
    }
    else {
        return [];
    }
}
const unknownError = 'Unknown error';
export function getErrorMessage(error) {
    if (typeof error === 'string') {
        return error || unknownError;
    }
    else if (error != null && typeof error === 'object' && typeof error.message === 'string') {
        return error.message || unknownError;
    }
    else if (error != null && typeof error.toString() === 'function') {
        try {
            const message = error.toString();
            if (typeof message === 'string') {
                return message || unknownError;
            }
        }
        catch (e) {
            console.error('Failed to call toString on error object', e);
        }
    }
    return unknownError;
}
